import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Routes } from 'src/constants/index';
import { BlueButton } from 'src/components/components/index';
import ConciergeTeamImageLarge from 'src/assets/images/concierge-team-large.png';
import './style.scss';

export class GetawayUniqueCollection extends React.Component {
  render(): React.ReactNode {
    return (
      <div className="getaway__unique">
        <div className="getaway__container getaway__unique-wrapper">
          <div className="getaway__unique-info">
            <p className="getaway__unique-info_title">
              <FormattedMessage id="getaway.unique.title" />
            </p>
            <p className="getaway__unique-info_text">
              <FormattedMessage id="getaway.unique.text" />
            </p>
          </div>
          <Link to={Routes.ConciergeTeam} className="getaway__unique-link">
            <BlueButton>
              <FormattedMessage id="talk.to.our.team" />
            </BlueButton>
          </Link>

          <img className="getaway__unique-img" src={ConciergeTeamImageLarge} alt="Concierge team" />
        </div>
      </div>
    );
  }
}
